import type {
  ClientLoaderFunctionArgs,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { DealDetailRouteComponent } from '@jane/bloom/components/routes/dealDetail/dealDetailComponent';
import { enhanceWithFilterState } from '@jane/bloom/loaders/clientLoader/filterStateManagement';
import { loadDealDetailRoute } from '@jane/bloom/loaders/routes/dealDetail.server';
import { dealDetailRouteMeta } from '@jane/bloom/resources/meta/routes/dealDetail';
import { ddTrace } from '@jane/bloom/services/dd-trace.server';
import type { RouteHandle } from '@jane/bloom/types/schemas/bloom/routeHandle';

export const handle: RouteHandle = {
  hydrate: true,
};

export const meta: MetaFunction<typeof loader> = (args) => {
  return dealDetailRouteMeta(args);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const serverLoader = await args.serverLoader<typeof loader>();
  const { filterArgs, searchCriteria } = serverLoader;
  return {
    ...serverLoader,
    availableFilters: await enhanceWithFilterState({
      filterArgs,
      searchCriteria,
    }),
  };
};
clientLoader.hydrate = true;

export const loader = async (args: LoaderFunctionArgs) =>
  ddTrace.initOnce().trace(
    'loader.$basename.store.$storeId.deals.$dealId.$slug',
    {
      measured: true,
    },
    async () => {
      return loadDealDetailRoute({ args, shouldPinStore: true });
    }
  );

export default function DealRoute() {
  return <DealDetailRouteComponent />;
}
